import angular from 'angular';
import angularUiRouter from '@uirouter/angularjs';

export default angular.module('settingsModule', [
    angularUiRouter,
    'cloudService',
    'shared',
    'ngTagsInput'
]);



// WEBPACK FOOTER //
// ./modules/settings/settings.module.js